import React, { useState, useMemo, useEffect } from 'react';
import DataTable, { defaultThemes } from 'react-data-table-component';
import { MultiSelect } from 'react-multi-select-component';
import { FilterComponent, ButtonComponent, EditButton, MultipleInput, DropDownComponent } from './UIComponent';

const defaultCustomStyles = {
    subHeader: {
        style: {
            padding: 0,
            justifyContent: 'space-between',
        }
    },
    headCells: {
        style: {
            fontSize: 13
        },
    },
    cells: {
        style: {
            
            paddingRight: '0',
            fontSize: screen_width >= mobile_width ? '13px' : "12px",
            '&:first-child button[id^=edit]': {
                visibility: 'hidden',
            },
            '&:first-child:hover button[id^=edit]': {
                visibility: 'visible',
            },
            '&:last-child button[id^=edit]': {
                visibility: 'hidden',
            },
            '&:last-child:hover button[id^=edit]': {
                visibility: 'visible',
            },
            '&:nth-last-child(2) button[id^=edit]': {
                visibility: 'hidden',
            },
            '&:nth-last-child(2):hover button[id^=edit]': {
                visibility: 'visible',
            },
            '&:nth-last-child(4) button[id^=edit]': {
                visibility: 'hidden',
            },
            '&:nth-last-child(4):hover button[id^=edit]': {
                visibility: 'visible',
            },    
        }
    }
}

// const customStyles = {
//     subHeader: {
//         style: {
//             padding: 0,
//             justifyContent: 'space-between',
//         }
//     },
//     header: {
//         style: {
//             minHeight: '56px',
//         },
//     },
//     headRow: {
//         style: {
//             borderTopStyle: 'solid',
//             borderTopWidth: '1px',
//             borderTopColor: defaultThemes.default.divider.default,
//         },
//     },
//     headCells: {
//         style: {
//             '&:not(:last-of-type)': {
//                 borderRightStyle: 'solid',
//                 borderRightWidth: '1px',
//                 borderRightColor: defaultThemes.default.divider.default,
//             },
//         },
//     },
//     cells: {
//         style: {
//             '&:not(:last-of-type)': {
//                 borderRightStyle: 'solid',
//                 borderRightWidth: '1px',
//                 borderRightColor: defaultThemes.default.divider.default,
//             },
//         },
//     },
// };

const DataTableComponent = ({ tableData, setTableData, addFilter, topButton, columnData, selectableRows, paginationPerPage, paginationRowsPerPageOptions, onSelectedRowsChangeEvent, progressPending, connectionType, filterColumnName = null, paginationStatus = true, tableHeight = null, informationTag, topFiltersFlag, topFiltersData }) => {

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [topFilterVal, setTopFilterVal] = useState({});
    const filteredItems = filterColumnName ? tableData.filter(item => item[filterColumnName] && item[filterColumnName].toLowerCase().includes(filterText.toLowerCase())) : tableData;
    let selectableRowStatus = selectableRows ? selectableRows : false;
    let paginationPerPageNo = paginationPerPage ? paginationPerPage : 10;
    let paginationRowsPerPageOptionsArr = paginationRowsPerPageOptions ? paginationRowsPerPageOptions : [10, 15, 20, 25, 30];
    let progressPendingStatus = progressPending ? progressPending : false;
    let placeHolderValue = null;

    useEffect(() => {
        setTimeout(() => {
            feather.replace();
        }, 5);
    }, [])

    let newColumnsArray = columnData.map(function (innerData) {

        let tempCell = { "selector": innerData.rawField, "name": innerData.virtualName, "ignoreRowClick": true, "allowOverflow": false, "sortable": innerData.sortable === false ? false : true, "center": innerData.centerAlign === true ? true : false, "minWidth": innerData.minWidth ? innerData.minWidth : null, "maxWidth": innerData.maxWidth ? innerData.maxWidth : null,
        cell:row => <div data-value={row[innerData.rawField]} className="dataTable-cell" title={row[innerData.rawField]}>{row[innerData.rawField] !== null && row[innerData.rawField].length > 35
        ? `${row[innerData.rawField].substring(0, 35)}...`
        : row[innerData.rawField]}</div>}
        innerData.rawField === filterColumnName ? placeHolderValue = innerData.virtualName : null

        if (innerData.type || innerData.displayType || innerData.edit || innerData.moreOption) {
            tempCell = {
                ...tempCell,
                cell: innerData.tableCell ? innerData.tableCell : (row, id, column, index) => {
                    return <>
                        {innerData.type == "avtar" && row[innerData.rawField] && screen_width >= mobile_width ? <div className="avatar avatar-sm mg-r-5"><span className="avatar-initial rounded-circle"> {row[innerData.rawField].charAt(0)}</span></div> : null}

                        {
                            innerData.type == "status" ?
                                <span className={`${row[innerData['statusField']] == 1 ? "text-success" : row[innerData['statusField']] == 4 ? "text-info" : row[innerData['statusField']] == 5 ? "text-muted" : "text-danger"}`}>
                                    <i className={`fas ${row[innerData['statusField']] == 1 || row[innerData['statusField']] == 4 ? "fa-check" : "fa-exclamation-triangle"} mg-r-10`}></i>
                                </span>
                                : null
                        }

                        {
                            innerData.type == "image" ? <div className="avatar avatar-sm mg-r-10"><img className="img wd-15 ht-15 rounded-circle" src={`${innerData.baseURL}/${row[innerData.rawField].toLowerCase()}.png`} /></div> : null
                        }

                        {
                            ["both", "date", "number", "dropDown", "dateTime"].indexOf(innerData.displayType) == -1
                                ? row[innerData.rawField] === ""
                                    ? row[innerData.rawField] = "-"
                                    : row[innerData.rawField] !== null && row[innerData.rawField].length > 25
                                        ? `${row[innerData.rawField].substring(0, 25)}...`
                                        : row[innerData.rawField]
                                : null
                        }

                        {
                            innerData.displayType === "date" ?
                                row[innerData.rawField] === "NA"
                                    ? <span>Not Applicable</span>
                                    : moment(row[innerData.rawField]).format("Do MMM YYYY")
                                : null
                        }
                        {
                            innerData.displayType === "dateTime" ?
                                row[innerData.rawField] === null
                                    ? <span>-</span>
                                    : moment(row[innerData.rawField]).format("Do MMM YYYY HH:mm")
                                : null
                        }

                        {innerData.displayType == "number" ? <div style={{ textAlign: "center", width: "100%" }}>{row[innerData.rawField]}</div> : null}

                        {
                            innerData.displayType == "both" && JSON.parse(row[innerData.rawField])["freq_type"] === "daily" ?
                                <div className="container pd-0" style={{ marginBottom: 0 }}>
                                    <div className="row no-gutters">
                                        <span className="col">
                                            <i className="far fa-file-alt fa-lg mg-r-5"></i>
                                            {JSON.parse(row[innerData.rawField])["freq_type"]
                                                ? JSON.parse(row[innerData.rawField])["freq_type"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["freq_type"].slice(1)
                                                : null}
                                        </span>
                                        <span className="col">
                                            <i className="far fa-clock fa-lg mg-r-5"></i>
                                            {moment(JSON.parse(row[innerData.rawField])["timeOfDay"], "HH:mm:ss").format("HH:mm")}
                                        </span>
                                        <span className="col" style={{ visibility: "hidden" }}>
                                            <i className="far fa-calendar fa-lg mg-r-5"></i>
                                            {/* NA */}
                                        </span>
                                    </div>
                                </div>
                                : innerData.displayType == "both" && JSON.parse(row[innerData.rawField])["freq_type"] === "once" ?
                                    <div className="container pd-0" style={{ marginBottom: 0 }}>
                                        <div className="row no-gutters">
                                            <span className="col">
                                                <i className="far fa-file-alt fa-lg mg-r-5"></i>
                                                {JSON.parse(row[innerData.rawField])["freq_type"]
                                                    ? JSON.parse(row[innerData.rawField])["freq_type"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["freq_type"].slice(1)
                                                    : null}
                                            </span>
                                            <span className="col">
                                                <i className="far fa-clock fa-lg mg-r-5"></i>
                                                {moment(JSON.parse(row[innerData.rawField])["timeOfDay"], "HH:mm:ss").format("HH:mm")}
                                            </span>
                                            <span className="col" style={{ visibility: "hidden" }}>
                                                <i className="far fa-calendar fa-lg mg-r-5"></i>
                                                {/* NA */}
                                            </span>
                                        </div>
                                    </div>
                                    : innerData.displayType == "both" && (JSON.parse(row[innerData.rawField])["freq_type"] === "weekly" || JSON.parse(row[innerData.rawField])["freq_type"] === "week") ?
                                        <div className="container pd-0" style={{ marginBottom: 0 }}>
                                            <div className="row no-gutters">
                                                <span className="col">
                                                    <i className="far fa-file-alt fa-lg mg-r-5"></i>
                                                    {JSON.parse(row[innerData.rawField])["freq_type"]
                                                        ? JSON.parse(row[innerData.rawField])["freq_type"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["freq_type"].slice(1)
                                                        : null}
                                                </span>
                                                <span className="col">
                                                    <i className="far fa-clock fa-lg mg-r-5"></i>
                                                    {moment(JSON.parse(row[innerData.rawField])["timeOfDay"], "HH:mm:ss").format("HH:mm")}
                                                </span>
                                                <span className="col">
                                                    <i className="far fa-calendar fa-lg mg-r-5"></i>
                                                    {JSON.parse(row[innerData.rawField])["dayOfWeek"]
                                                        ? JSON.parse(row[innerData.rawField])["dayOfWeek"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["dayOfWeek"].slice(1)
                                                        : null}
                                                </span>
                                            </div>
                                        </div>

                                        : innerData.displayType == "both" && JSON.parse(row[innerData.rawField])["freq_type"] === "monthly" ?
                                            <div className="container pd-0" style={{ marginBottom: 0 }}>
                                                <div className="row no-gutters">
                                                    <span className="col">
                                                        <i className="far fa-file-alt fa-lg mg-r-5"></i>
                                                        {JSON.parse(row[innerData.rawField])["freq_type"]
                                                            ? JSON.parse(row[innerData.rawField])["freq_type"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["freq_type"].slice(1)
                                                            : null}
                                                    </span>
                                                    <span className="col">
                                                        <i className="far fa-clock fa-lg mg-r-5"></i>
                                                        {moment(JSON.parse(row[innerData.rawField])["timeOfDay"], "HH:mm:ss").format("HH:mm")}
                                                    </span>
                                                    <span className="col">
                                                        <i className="far fa-calendar fa-lg mg-r-5"></i>
                                                        {JSON.parse(row[innerData.rawField])["dayOfMonth"]
                                                            ? JSON.parse(row[innerData.rawField])["dayOfMonth"].charAt(0).toUpperCase() + JSON.parse(row[innerData.rawField])["dayOfMonth"].slice(1)
                                                            : null}
                                                    </span>
                                                </div>
                                            </div>
                                            : innerData.displayType == "both" && JSON.parse(row[innerData.rawField])["freq_type"] === "" ?
                                                <span>Not Assigned</span>
                                                : null
                        }
                        {innerData.edit == "input" ? <EditButton state={tableData} stateToSet={setTableData} data={row} rowNumber={id} columnName={column} /> : null}
                        {innerData.edit == "mulitpleInput" ? <MultipleInput state={tableData} stateToSet={setTableData} connectionType={connectionType} data={row} rowNumber={id} columnName={column} /> : null}

                        {innerData.edit == "dropDown" ? innerData.options ? <><span>{innerData.options[row[innerData.rawField]].name}</span><DropDownComponent state={tableData} stateToSet={setTableData} dropdownOption={Object.values(innerData.options)} dropDownValue={innerData.options[row[innerData.rawField]].value} data={row} rowNumber={id} columnName={column} /></> : null : null}

                        {
                            innerData.moreOption && innerData.moreOption.length > 1 ?
                                <div className="dropdown-file" style={{ position: 'static', marginLeft: 'auto' }}>
                                    <a href="" className="dropdown-link dropdown" data-bs-toggle="dropdown"><i title="Edit" className="fas fa-ellipsis-v"></i></a>
                                    <div className="dropdown-menu dropdown-menu-start">
                                        {
                                            innerData.moreOption.map(function (moreOptionData) {

                                                return (<a href="javascript:void(0)" className="dropdown-item details"
                                                    onClick={moreOptionData.action == "callback" ? () => { moreOptionData.event(row, moreOptionData.type) } : null}
                                                >
                                                    {moreOptionData.icon ? <i className={`${moreOptionData.icon} mg-r-5`}></i> : null}
                                                    {moreOptionData.name}
                                                </a>)
                                            })
                                        }
                                    </div>
                                </div> : null
                        }
                    </>
                }
            }
        }
        return tempCell
    })

    let subHeaderComponentMemo = null;
    if (topButton || addFilter || informationTag || topFiltersFlag) {
        subHeaderComponentMemo = useMemo(() => {
            const handleClear = () => {
                if (filterText) {
                    setResetPaginationToggle(!resetPaginationToggle);
                    setFilterText('');
                }
            };

            const handleSelectedVal = (e, filterVal) => {
                let tempObject = JSON.parse(JSON.stringify(topFiltersData))
                Object.keys(topFiltersData).map(function (innerData) {
                    if (filterVal === innerData)
                        tempObject[innerData] = e
                })
                setTopFilterVal(tempObject)
            }
            let filter_options = null
            if (topFiltersData && Object.keys(topFiltersData).length > 0) {
                filter_options = Object.keys(topFiltersData).map(function (innerData, index) {
                    return (
                        <div className='mg-b-10 mg-l-10' id={`top_filter_${index}`} key={`top_filter_${index}`}>
                            <span>{topFiltersData[innerData]['label']}</span>
                            <MultiSelect
                                key={`${innerData}_dropdown_${Math.floor(Math.random() * 10)}`}
                                className={`${innerData}_dropdown`}
                                options={topFiltersData[innerData]['options']}
                                value={topFilterVal[innerData] ? topFilterVal[innerData] : []}
                                onChange={(e) => handleSelectedVal(e, innerData)}
                            />
                        </div>
                    )
                });
            }


            return (<>
                <div className={`d-flex flex-row justify-content-start ${screen_width >= mobile_width ? '' : 'pd-l-5'}`}>
                    {topButton ? topButton.map((innerData) => <ButtonComponent buttonData={innerData} />) : null}
                    {addFilter ? <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} placeHolderValue={placeHolderValue} responsivenessSearch = {true}/> : null}
                </div>
                <div className='justify-content-end'>
                    {topFiltersFlag && filter_options && filter_options.length > 0
                        ? <div className="row mg-r-1">
                            {filter_options}
                        </div>
                        : null}
                </div>
                {
                    informationTag
                        ? <span className={`alert alert-primary pd-8 tx-medium tx-12 tx-san ${screen_width >= mobile_width ? '' : 'mg-t-5'}`}>
                            <i data-feather="alert-circle" className="mg-r-10" width="20" height="20"></i>
                            {informationTag.displaySentence}
                        </span>
                        : null
                }
            </>);
        }, [filterText, resetPaginationToggle, topButton, informationTag, topFiltersData, topFilterVal]);
    }
    
    return (
        <DataTable
            className="table table-bordered"
            fixedHeaderScrollHeight={tableHeight ? tableHeight : null}
            customStyles={defaultCustomStyles}
            columns={newColumnsArray}
            data={filteredItems}
            highlightOnHover={true}
            pointerOnHover={false}
            responsive={true}
            fixedHeader={true}
            noHeader
            hover
            subHeader={subHeaderComponentMemo ? true : false}
            subHeaderComponent={subHeaderComponentMemo}
            pagination={paginationStatus}
            paginationResetDefaultPage={resetPaginationToggle}
            paginationPerPage={paginationPerPageNo}
            paginationRowsPerPageOptions={paginationRowsPerPageOptionsArr}
            persistTableHead
            selectableRows={selectableRowStatus}
            onSelectedRowsChange={onSelectedRowsChangeEvent}
            progressPending={progressPendingStatus}
        />
    )
}

export default DataTableComponent;
